<div class="page-title animatedBackground">
    <div class="container">
        <h3>About Us</h3>
        <ul>
            <li><a router="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>About Us</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="features-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-12">
                <div class="repair-about-image">
                    <img src="assets/img/about_us_1.png" alt="image">
                    <img src="assets/img/about_us_2.png" alt="image">
                </div>
            </div>

            <div class="col-lg-7 col-md-12">
                <div class="repair-about-content">
                    <div class="section-title">
                        <span>About Us</span>
                        <h3>Creating Content Celebrating Champions</h3>
                        <p>Welcome to AM Media and Sports Pvt Ltd—where media and sports come together to inspire,
                            educate, and empower communities through innovative storytelling and dynamic sporting
                            experiences. We are a forward-thinking platform dedicated to making content and sports
                            accessible, inclusive, and impactful for everyone.</p>

                        <p class="mt-2">

                        </p>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="single-about-box">
                                <i class="icofont-eye-open"></i>
                                <h3>Our Vision</h3>
                                <p>
                                    Our vision is to become a leading platform where media and sports converge to
                                    inspire, educate, and empower communities. We envision a future where our innovative
                                    courses, inclusive media content, and transformative sporting events foster a
                                    culture of diversity, excellence, and social responsibility. By bridging media and
                                    sports, we aim to create a global impact, nurturing talent, promoting positive
                                    change, and enriching lives.
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="single-about-box">
                                <i class="icofont-dart"></i>
                                <h3>Our Mission</h3>
                                <p>
                                    Our mission is to empower communities through innovative content creation and
                                    dynamic sporting events. We aim to educate, inspire, and entertain while fostering
                                    talent and teamwork, ensuring equal opportunities for all, and driving positive
                                    change across diverse platforms.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row ptb-100 align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="features-text">
                    <h3>Training in Inclusive Media and Filmmaking</h3>
                    <p>At the heart of our work is comprehensive training open to all aspiring creators. We offer
                        specialized courses in audio description, translation, voice acting, transcription, and audio
                        descriptive sports commentary. Our filmmaking courses cover a wide range of skills essential for
                        creating impactful corporate films, educational films, documentaries, and more.
                    </p>
                    <ul>
                        <li>While our
                            initial focus is on training, these programs are designed to empower people from all
                            backgrounds.</li>
                        <li>Especially persons with disabilities, women, and rural youth. helping them gain skills that
                            translate into meaningful careers.</li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="img mb-0">
                    <img src="assets/img/training_and_media_about.png" alt="image">
                </div>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="img">
                    <img src="assets/img/expanding_content_creation_about.png" alt="image">
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="features-text mb-0">
                    <h3>Expanding Content Creation Services</h3>
                    <p>Building on our training foundation, we will soon extend our services to include professional
                        content creation such as corporate films, educational videos, documentaries, and sports-related
                        media projects.</p>
                    <ul>
                        <li>Our goal is to produce high-quality, inclusive content that celebrates champions and tells
                            stories that matter.</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="row ptb-100 align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="features-text">
                    <h3>Post-Production and Outsourcing</h3>
                    <p>
                        We provide end-to-end post-production services including editing, localization, and quality
                        assurance, ensuring that media and sports content is polished, accessible, and ready for diverse
                        audiences.
                    </p>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="img mb-0">
                    <img src="assets/img/post_production_outsource_about.png" alt="image">
                </div>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="img">
                    <img src="assets/img/Inclusive_Sports_Initiatives.png" alt="image">
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="features-text mb-0">
                    <h3>Inclusive Sports Initiatives</h3>
                    <p>
                        We collaborate with sports federations to make their events more inclusive and accessible.
                        Beyond support, we organize sporting events and training programs that encourage participation
                        from athletes of all abilities, fostering a spirit of competition and community.
                    </p>
                </div>
            </div>
        </div>

        <div class="row ptb-100 align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="features-text">
                    <h3>Empowerment Through Opportunity</h3>
                    <p>
                        Our skilling programs are designed to open doors for marginalized communities, including persons
                        with disabilities, women, and rural youth, without excluding anyone. We believe in equal
                        opportunity for all and strive to create pathways for employment, remote work, and community
                        growth across regional languages and platforms.
                    </p>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="img mb-0">
                    <img src="assets/img/Empowerment_Through_Opportunity.png" alt="image">
                </div>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="img">
                    <img src="assets/img/Leadership_With_Purpose.png" alt="image">
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="features-text mb-0">
                    <h3>Leadership With a Purpose</h3>
                    <p>
                        Founded by women leaders who bring lived experience in disability, sports, financial services,
                        and media, AM Media and Sports is deeply committed to inclusion and social impact.
                    </p>
                    <ul>
                        <li>Our leadership has been instrumental in pioneering inclusive sports movements such as Yes,
                            We Too Can, the Wheelchair Basketball Federation of India, and the Paralympic Swimming
                            Association of Tamil Nadu, as well as initiatives like Inclusive Education in the
                            Entertainment Industry through the Lights Camera Inclusion Project. </li>
                        <li>. This diverse expertise reflects our dedication to meaningful change and our ability to
                            drive innovation across both media and sports sectors.</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="row ptb-100 align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="features-text">
                    <h3>Join the Movement</h3>
                    <p>
                        At AM Media and Sports, we believe inclusion is for everyone. Our training programs, content
                        services, and sporting initiatives are open to all individuals eager to learn, grow, and
                        contribute—whether you are a person with disabilities, a woman, a rural youth, or anyone
                        passionate about media and sports.
                    </p>
                    <ul>
                        <li>We invite content creators, broadcasters, sports federations, educators, and changemakers to
                            partner with us in creating stories and events that celebrate champions from every
                            background. </li>
                        <li>Together, we can build a future where talent is nurtured, opportunities are equal, and every
                            achievement is celebrated.</li>
                        <li>Let’s innovate, empower, and transform the landscape of media and sports—creating content
                            that truly celebrates champions.</li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="img mb-0">
                    <img src="assets/img/Join_the_Movement.png" alt="image">
                </div>
            </div>
        </div>
    </div>
    <div class="vector"><img src="assets/img/vector-bg.png" alt="vector"></div>
</section>

<section *ngIf="false" class="testimonial-area ptb-100 bg-fbf9f8">
    <div class="container">
        <div class="section-title">
            <span>Testimonial</span>
            <h3>What our client are saying</h3>
            <p>We enjoy adapting our strategies to offer every client the best solutions that are at the forefront of
                the industry.</p>
        </div>
        <div class="feedback-slides owl-carousel owl-theme">
            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar1.jpg" alt="client">
                    </div>
                    <h4>Josh Buttler</h4>
                    <span>Web Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar2.jpg" alt="client">
                    </div>
                    <h4>David Andy</h4>
                    <span>Web Designer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar3.jpg" alt="client">
                    </div>
                    <h4>Lina D'Souja</h4>
                    <span>QA Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar1.jpg" alt="client">
                    </div>
                    <h4>Sarah Taylor</h4>
                    <span>Team Lead</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar2.jpg" alt="client">
                    </div>
                    <h4>John Smith</h4>
                    <span>Web Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar3.jpg" alt="client">
                    </div>
                    <h4>Eva Lucy</h4>
                    <span>PHP Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>
        </div>
    </div>
    <div class="vector"><img src="assets/img/vector-bg.png" alt="vector"></div>
</section>

<section class="team-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Our Team</span>
            <h3>Our Best Experts</h3>
            <p>We enjoy adapting our strategies to offer every client the best solutions that are at the forefront of
                the industry.</p>
        </div>

        <div class="row">
            <section class="services-details-area">
                <div class="container">
                    <div class="services-details-overview">
                        <div class="row services-details-desc">
                            <h3>Madhavi Latha Prathigudupu – Co-Founder & Director</h3>
                            <p>
                                Madhavi is a trailblazer in adaptive sports and inclusive media, co-founding the
                                Paralympic Swimming Association of Tamil Nadu and the Wheelchair Basketball Federation
                                of India. With extensive experience in sports and media—including producing films
                                screened at the International Film Festival of India—she leads AM Media and Sports to
                                connect the excitement of sports with powerful storytelling, ensuring inclusion and
                                visibility for all.
                            </p>
                            <p class="mt-1">For more details visit to link: <a href="http://www.pmlatha.com/"
                                    target="_blank">Madhavi
                                    Latha Prathigudupu</a></p>
                            <div class="features-text">
                                <h4><i class="icofont-check-alt"></i> Experience</h4>
                                <p>
                                    A former national para swimming champion with over 30 medals, Madhavi also built a
                                    distinguished 30-year career in retail and corporate banking. Her inspirational
                                    autobiography, Swimming Against the Tide, and her role as a keynote speaker at
                                    various national and international forums amplify her advocacy for inclusion and
                                    empowerment.
                                </p>
                            </div>
                        </div>
                        <div class="services-details-image">
                            <img src="assets/img/Madhavi_Latha.jpg" alt="image">
                        </div>
                    </div>
                    <div class="services-details-overview">
                        <div class="services-details-2">
                            <div class="features-text">
                                <h4><i class="icofont-check-alt"></i> Strategic Edge</h4>
                                <p class="mt-3">
                                    Madhavi’s unique expertise in adaptive sports, accessible media production, and
                                    corporate DEI strategy fuels innovation at AM Media and Sports. Her acclaimed films
                                    and public speaking engagements amplify stories of resilience and inclusion, while
                                    her leadership in national sports federations and advisory boards strengthens the
                                    company’s impact.
                                </p>
                            </div>
                            <div class="mt-4 features-text">
                                <h4><i class="icofont-check-alt"></i> AM Media and Sports</h4>
                                <p class="mt-3">
                                    Under Madhavi’s guidance, AM Media and Sports produces inclusive sporting events,
                                    accessible media content, and innovative training programs. Her vision makes
                                    inclusion the foundation of stronger systems and better stories, creating a platform
                                    where every athlete and story is valued.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="services-details-overview">
                        <div class="services-details-image">
                            <img src="assets/img/Aruna_Munukutla.png" alt="image">
                        </div>

                        <div class="services-details-desc">
                            <h3>Aruna Munukutla – Co-Founder & Director</h3>
                            <p>
                                Aruna is the strategic powerhouse behind AM Media and Sports, driving growth with
                                visionary leadership. As co-owner of 4AT Consulting, she has consistently shattered
                                revenue targets and expanded the firm to a global team of 100 professionals across the
                                US and India.
                            </p>
                            <div class="features-text">
                                <h4><i class="icofont-check-alt"></i> Experience</h4>
                                <p>
                                    A Chartered Accountant with an MBA in Finance and Marketing, Aruna combines Big 4
                                    expertise with entrepreneurial spirit. Her deep knowledge in Accounting, Audit, and
                                    Advisory fuels AM Media and Sports’ growth and agility in a competitive landscape.
                                </p>
                            </div>
                            <div class="features-text">
                                <h4><i class="icofont-check-alt"></i> Strategic</h4>
                                <p>
                                    Aruna’s mastery of complex regulations and market dynamics ensures confident
                                    navigation in media and sports sectors. Her relentless innovation and strategic
                                    foresight ignite a culture of excellence and limitless possibility within the
                                    company.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="services-details-overview">
                        <div class="services-details-2">
                            <div class="features-text">
                                <h4><i class="icofont-check-alt"></i> AM Media and Sports</h4>
                                <p class="mt-3">
                                    Under Aruna’s leadership, AM Media and Sports is more than a business—it’s a
                                    movement committed to revolutionizing inclusion through media and sports, turning
                                    accessibility and equity from ideals into reality.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</section>